import { request } from '@/utils/request'

export const reqLandmarkList = (params) =>
  request.get(`/landmark/getlist`, { params })

export const reqAddLandmark = (payload) =>
  request.post(`landmark/create`, payload)

export const reqUpdateLandmark = (id, payload) =>
  request.put(`landmark/update/?id=${id}`, payload)

export const reqDeleteLandmark = (id) =>
  request.delete(`landmark/delete/?id=${id}`)



// WEBPACK FOOTER //
// ./src/api/landmark/index.js